import Link from "next/link";

export const FinalCta = () => (
  <div className="px-6 pb-24 pt-8">
    <div className="max-w-[1140px] mx-auto bg-foreground text-background rounded-2xl p-14 flex justify-between items-center gap-8 flex-wrap relative overflow-hidden">
      <div
        className="absolute inset-0 bg-[radial-gradient(circle_at_80%_50%,oklch(0.569_0.195_269_/_0.25)_0%,transparent_60%)] pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative z-[1]">
        <h2 className="font-serif text-[clamp(28px,4vw,40px)] leading-[1.1] font-normal tracking-tight text-balance flex flex-col gap-2">
          <span>Stop showing your friends localhost:3000.</span>
          <em className="text-primary">Get a real link.</em>
        </h2>
      </div>
      <div className="flex gap-3 items-center flex-wrap relative z-[1]">
        <Link
          href="/dashboard"
          className="plausible-event-name=L2_TrialStarted bg-background text-foreground px-6 py-3.5 rounded-full text-[14.5px] font-semibold hover:-translate-y-px hover:bg-accent transition-all inline-block"
        >
          Start for free
        </Link>
        <Link
          href="/pricing"
          className="plausible-event-name=L2_SeePricing text-background/85 bg-transparent border-1 px-6 py-3.5 rounded-full text-sm font-medium hover:text-background hover:bg-background/8 hover:border-background/60 transition-all inline-block"
        >
          See pricing →
        </Link>
      </div>
    </div>
  </div>
);
